import { render, staticRenderFns } from "./FrzListSupplyPallet.vue?vue&type=template&id=a9c18586&v-slot%3Ano-data=true"
import script from "./FrzListSupplyPallet.vue?vue&type=script&lang=js"
export * from "./FrzListSupplyPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports